import { useRegistryScript } from "#nuxt-scripts-utils";
import { object, string, optional, boolean } from "#nuxt-scripts-validator";
import { stringSchema } from '~/schemas'
import { AdblockDetector } from 'adblock-detector';
import { withQuery } from 'ufo'

export const GoogleAnalyticsOptions = object({
  id: string(),
  l: optional(string()),
  sendPageView: optional(boolean()),
});

function use(options) {
  const gtag = function(...args) {
    window["gtag-" + (options.l ?? "dataLayer")](...args);
  };
  return {
    dataLayer: window[options.l ?? "dataLayer"],
    gtag
  };
}

export function useCustomGoogleAnalytics(_options) {
  const runtimeConfig = useRuntimeConfig()
  const adbDetector = new AdblockDetector()

  const apiUrl = stringSchema.url().parse(runtimeConfig.public.apiBaseUrl);
  return useRegistryScript(_options?.key || "googleAnalytics", (options) => ({
    scriptInput: {
      src: adbDetector.detect() ? apiUrl + `/ga/script/${options.id}`:
        withQuery("https://www.googletagmanager.com/gtag/js", { id: options?.id, l: options?.l }),
    },
    schema: import.meta.dev ? GoogleAnalyticsOptions : void 0,
    scriptOptions: {
      use: () => use(options),
      stub: import.meta.client ? void 0 : ({ fn }) => {
        return fn === "dataLayer" ? [] : void 0;
      },
      performanceMarkFeature: "nuxt-third-parties-ga",
      ...{ tagPriority: 1 }
    },
    clientInit: import.meta.server ? void 0 : () => {
      window[options?.l ?? "dataLayer"] = window[options?.l ?? "dataLayer"] || [];
      window["gtag-" + (options?.l ?? "dataLayer")] = function() {
        window[options?.l ?? "dataLayer"].push(arguments);
      };
      window["gtag-" + (options?.l ?? "dataLayer")]("js", /* @__PURE__ */ new Date());
      window["gtag-" + (options?.l ?? "dataLayer")]("config", options?.id, { send_page_view: options?.sendPageView ?? true });
    }
  }), _options);
}
